import dynamic from 'next/dynamic';
import { memo, useCallback, useMemo } from 'react';
import { I_FloorplanConfig, I_Floorplan } from '@containers/Home/types';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { selectListScene } from '@containers/Home/selectors';
import { MarkerWrapper } from './styled';

const Radar = dynamic(() => import('./Radar'));

interface Props {
  northRadar: number;
  isActive: boolean;
  isTurnOnRadar: boolean;
  marker: I_Floorplan['markers'][0];
  configMarker?: I_FloorplanConfig['marker'];
  configRadar: I_FloorplanConfig['radar'];
  onClick: (marker: I_Floorplan['markers'][0]) => void;
}

const Marker = memo(
  ({
    marker,
    isTurnOnRadar,
    configMarker,
    configRadar,
    northRadar,
    isActive,
    onClick,
  }: Props) => {
    const listScene = useSelector(selectListScene);

    const sceneSelected = useMemo(
      () =>
        listScene.filter(item => item.id === marker.target_scene_id)[0] ||
        undefined,
      [listScene, marker],
    );

    const onClickMarker = useCallback(() => onClick(marker), [marker, onClick]);

    return (
      <Tooltip title={sceneSelected?.title || 'N/A'}>
        <MarkerWrapper
          id={marker.id}
          style={{
            left: `${marker.left}%`,
            top: `${marker.top}%`,
            backgroundColor: `${configMarker?.bgColor}`,
            borderColor: `${configMarker?.borderColor}`,
          }}
          onClick={onClickMarker}
          onTouchStart={onClickMarker}
          className={isActive ? 'active' : ''}
        >
          {isActive && isTurnOnRadar && (
            <Radar
              width={configRadar.width}
              bgColor={configRadar.bgColor}
              north={northRadar || 0}
              borderColor={configRadar.borderColor}
              borderWidth={configRadar.borderWidth}
            />
          )}
        </MarkerWrapper>
      </Tooltip>
    );
  },
);

export default Marker;
